import React from 'react'
// libs
import styled from 'styled-components'
// view components
import ActivityDetails from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ActivityDetails/Index'
import SubActivitiesListContainer from 'containers/Activities/components/SubActivitiesList'
// graphql
import { SUB_ACTIVITIES_LIST_QUERY } from 'graphql/activities/queries'
// context
import { ActivitiesListBLContext } from 'containers/Activities/layers/BL/ActivitiesList'
import { ActivityBLContext } from 'containers/Activities/layers/BL/Activity'
// types
import { LogActionTypes } from 'types/graphql'

const ContentWrapper = styled.div`
  padding-left: 44px;
  height: auto;
  width: 100%;
`

const Activity: React.FC = () => {
  const { isSubActivities } = React.useContext(ActivitiesListBLContext)
  const { activity } = React.useContext(ActivityBLContext)

  return (
    <>
      <ActivityDetails />

      {!isSubActivities && (
        <ContentWrapper>
          <SubActivitiesListContainer
            isSubActivities
            entity={activity}
            query={SUB_ACTIVITIES_LIST_QUERY}
            variables={{
              filter: { entityId: activity.id, actionType: [LogActionTypes.Create, LogActionTypes.Update] }
            }}
          />
        </ContentWrapper>
      )}
    </>
  )
}

export default Activity
